import React from "react";
import { Box } from "@mui/material";

/**
 * A glowing, glass-like animated orb with a rotating gradient.
 * Renders soft particle effects around the orb for a magical feel.
 *
 * @param {object} props
 * @param {"idle"|"thinking"|"celebrating"} props.intensity - animation intensity
 * @param {"small"|"medium"|"large"} props.size - orb size variant
 */
const SIZE_MAP = {
  small: 64,
  medium: 96,
  large: 120,
};

const AnimatedOrb = ({ intensity = "idle", size = "large" }) => {
  const px = SIZE_MAP[size] || SIZE_MAP.large;

  return (
    <Box className={`guide-orb guide-orb--${intensity} guide-orb--${size}`}>
      {/* Soft glow layer */}
      <Box
        className="guide-orb__glow"
        sx={{ width: px * 1.8, height: px * 1.8 }}
      />

      {/* Main glass sphere */}
      <Box className="guide-orb__sphere" sx={{ width: px, height: px }}>
        {/* Rotating gradient inside the orb */}
        <Box className="guide-orb__gradient" />

        {/* Glass highlight */}
        <Box className="guide-orb__highlight" />

        {/* Inner glow */}
        <Box className="guide-orb__inner-glow" />
      </Box>

      {/* Floating particles */}
      {[...Array(6)].map((_, i) => (
        <Box
          key={i}
          className={`guide-orb__particle guide-orb__particle--${i}`}
        />
      ))}
    </Box>
  );
};

export default AnimatedOrb;
